export default __webpack_public_path__ + "static/melting-7184d5c286cc378f1466aa52d9e57139.png";